import clsx from "clsx";
import type { ReactNode } from "react";

type AlertTone = "error" | "success" | "info";

const TONE_CLASS: Record<AlertTone, string> = {
    error: "bg-[var(--color-error-bg)] text-[var(--color-error-text)]",
    success:
        "border border-[var(--color-success)]/30 bg-[var(--color-success)]/10 text-[var(--color-success-text)]",
    info: "bg-[var(--color-primary)]/10 text-[var(--color-primary)]",
};

export function Alert({
    tone = "error",
    children,
    className,
}: {
    tone?: AlertTone;
    children: ReactNode;
    className?: string;
}) {
    return (
        <p className={clsx("rounded-xl px-3 py-2.5 text-sm", TONE_CLASS[tone], className)}>
            {children}
        </p>
    );
}
